// DatoCMS `url` fields can already carry a query string (e.g. `?auto=format`).
// Appending `?w=828&...` to those produced `...?auto=format?w=828&...`, which
// imgix rejects wholesale — it served the FULL-SIZE original (measured: 7.9MB
// instead of 125KB for a property hero). Always build imgix URLs through this
// helper: it strips any existing query before appending the params.
export const imgixUrl = (url, params) =>
  `${String(url || "").split("?")[0]}?${params}`
